import { render, staticRenderFns } from "./Servertemplate.vue?vue&type=template&id=9d7d9d94&"
import script from "./Servertemplate.vue?vue&type=script&lang=js&"
export * from "./Servertemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports